import classNames from 'classnames/bind';
import { useState } from 'react';

import useClickOutside from '../../hooks/useClickOutside/useClickOutside';
import Styles from './quickActionsDropdown.module.scss';

const cx = classNames.bind(Styles);
const ANIMATION_DURATION = 200;

interface Option {
  label: string;
  onClick: () => void;
  content: React.ReactNode;
  danger?: boolean;
}

interface Props {
  disabled?: boolean;
  options: Option[];
  children?: React.ReactNode;
}

const QuickActionsDropdown = ({ disabled, options, children, ...props }: Props) => {
  const [open, setOpen] = useState(false);
  const [animationClass, setAnimationClass] = useState('closed');

  const ref = useClickOutside<HTMLSpanElement>(() => toggleMenu(false), open);

  const toggleMenu = async (newVal) => {
    setAnimationClass(newVal ? 'open' : 'closed');
    !newVal && (await new Promise((resolve) => setTimeout(resolve, ANIMATION_DURATION)));
    setOpen(newVal);
  };

  const closeAfter = (fn) => async () => {
    fn();
    await toggleMenu(false);
  };

  return (
    <span className={cx('container')} ref={ref}>
      <button
        onClick={() => toggleMenu(!open)}
        className={cx('button') + ' content-between'}
        disabled={disabled}
        {...props}
        aria-label='Quick Actions'>
        {children ? children : <i className={'fa-solid fa-ellipsis-vertical'}></i>}
      </button>
      {open && (
        <ul className={cx('menu', animationClass)}>
          {options.map(({ label, onClick, content, danger }, index) => (
            <li key={index}>
              <button
                onClick={closeAfter(onClick)}
                aria-label={label}
                className={cx({ danger: danger }) + ' content-between'}>
                {content}
              </button>
            </li>
          ))}
        </ul>
      )}
    </span>
  );
};

export default QuickActionsDropdown;
